import { render, staticRenderFns } from "./textMessage.vue?vue&type=template&id=8100c92a&"
import script from "./textMessage.vue?vue&type=script&lang=js&"
export * from "./textMessage.vue?vue&type=script&lang=js&"
import style0 from "./textMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports